// 运营-报警列表api
import request from '@/util/request'
import axios from 'axios'
const CancelToken = axios.CancelToken
let cancel
export function cancelRequest () {
  if (typeof cancel === 'function') {
    // 取消请求
    cancel()
  }
}

export function deleteDevice (data) {
  // 删除设备
  return request({
    url: `/device-s/device/delete-device `,
    method: 'post',
    data
  })
}

// 批量删除
export function batchDel (data) {
  return request({
    url: `/device-s/device/delete-device-by-file`,
    method: 'post',
    data
  })
}

// 添加设备
export function addDevice (data) {
  return request({
    url: `/device-s/device/add-device`,
    method: 'post',
    data
  })
}

// 批量添加设备
export function batchAddDevice (data) {
  return request({
    url: `/device-s/device/add-device-by-file`,
    method: 'post',
    data
  })
}
// 根据设备ID获取电站列表
export function getStationList (data) {
  return request({
    url: `/device-s/device/get-stations-by-deviceId`,
    method: 'post',
    data
  })
}

// 自动关联电站
export function autoAssociate (data) {
  return request({
    url: `/device-s/device/auto-associate-station`,
    method: 'post',
    data
  })
}

// 产品设备列表
export function productDeviceList (data, params) {
  return request({
    url: `/device-s/device/product-device-list`,
    method: 'post',
    data,
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/device/device/device.js